// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1OHCv","productName":"Table_productName__11XFu"};